import AlertModalActions from '../actions/A_Alert_Modal';

const initalState = {
  isModalOpen: false,
  data: {type: null, message: null, boldMessage: null},
};

const AlertModalReducer = (state = initalState, action) => {
  const { type, payload } = action;

  switch (type) {
    case AlertModalActions.types.ALERT_MODAL_SHOW:
      return { isModalOpen: true, data: {...payload} };

    case AlertModalActions.types.ALERT_MODAL_HIDE:
      return { isModalOpen: false, data: {type: null, message: null, boldMessage: null} };

    default:
      return state;
  }
};

export default AlertModalReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_alert_modal.js